module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {

	var _ = {
		bindToImgJquery: function (w, $img) {
			fox.each(w.getOption('handleDom'), function (v, alias) {
				if (v.target === 'img' || (fox.isArray(v.target) && v.target.indexOf('img') !== -1)) {
					$img.on(v.event, fox.bind(function (e) {
						if (fox.isFunction(v.callback.subj)) {
							v.callback.subj.call(this, e.target, alias, this, e);
						} else if (fox.isString(v.callback.subj)) {
							fox.oop.getRealCallback(v.callback)(e.target, alias, this, e);
						}
					}, v.callback.scope));
				}
			}, w);

			return $img;
		},

		mixBigThumb: function (bt, ot) {
			var 
				w = window.screen.width,
				h = window.screen.height;

			return bt.map(function (v, indx){
				var
					iw = Number(v.info.width),
					ih = Number(v.info.height);

				if ((iw <= w && ih <= h) || (ih <= h && iw <= w)) {
					return ot[indx];
				}

				return v;
			});
		}
	};
	
	fox.registerWidget('FullscreenView', {

		mixBigThumb: function () {
			return _.mixBigThumb.apply(this, arguments);
		},

		configure: function () {
			this.curEffect = 'fadeInDown';
			this.IMGCACHE = {};
			this.targetsIds = [];

			this.registerOptions('', {
				slideSwitchInterval: 5000,
				embed: {
					container: 'body',
					widget: '@root',
					location: 'firstChild'
				},
				template: 'sitepage_gallery_fullscreenview',
				autoRender: false,
				widgets: {
					body: {
						widget: 'Widget',
						'embed.container': '.gallery-fullscreen',
						autoRender: false,
						template: 'sitepage_gallery_fullscreenview_image',
						'hooks.onStartAddedToDom': '@parent:bodyOnStartAddedToDom'
					},
					currentRating: {
						widget: 'Social_Rating',
						'embed.container': '.gallery-sidebar-content #gallery-rating',
						template: 'sitepage_gallery_fullscreenview_rating',
						subject: 'resource'
					},
					imageFavorite: {
						widget: 'Social_Favorite',
						'embed.container': '.gallery-sidebar-content #gallery-favorite',
						template: 'sitepage_gallery_fullscreenview_favorite',
						subject: 'resource'
					},
					imageComments: {
						showComments: true,
						widget: 'Social_Comments',
						template: 'sitepage_gallery_fullscreenview_social_comment_scene',
						'embed.container': '.gallery-sidebar-content #gallery-comments',
						subject: 'resource',
						skipParentId: true,
						form: {
							template: 'sitepage_gallery_fullscreenview_social_comments_addform'
						}
					}
				},
				handleWom: {
					doubleTap: {
						event: 'doubleTap',
						widget: '@this',
						callback: 'showRealPixel'
					}
				},
				handleDom: {
					toogleSidebar: {
						target: '.gallery-toggle-arrow',
						callback: fox.bind(function (el) {
							if (!this.slideshowStarted) {
								$(el).parent().toggleClass('opened');
							}
						}, this)
					},

					handleControlClick: {
						target: '.key.normal',
						callback: 'handleKeydown'
					},
					showRealPixel: {
						target: '#show-real-pixel',
						callback: function (el) {
							if (!$(el).hasClass('real-px')) {
								this.showRealPixel();
								$(el).addClass('real-px');
							} else {
								$(el).removeClass('real-px');
								this.hideRealPixels(el);
							}
						}
					},
					exitFullscreen: {
						target: '.gallery-fullscreen-hide',
						callback: 'hide'
					},
					downloadPhoto: {
						target: '#download-photo',
						callback: 'downloadPhoto'
					},
					startSlideshow: {
						target: '#start-slide-show',
						callback: 'startSlideshow'
					},
					stopSlideshowHandler: {
						target: '.gallery-fullscreen-stop-slide-show',
						callback: 'stopSlideshowHandler'
					},
					touchStartOnSidebar: {
						event: 'touchstart',
						target: '.gallery-sidebar',
						callback: fox.bind(function (el, alias, scope, event) {
							// console.log('START>>>', event);
						}, this)
					},
					touchMoveOnSidebar: {
						event: 'touchmove',
						target: '.gallery-sidebar',
						callback: fox.bind(function (el, alias, scope, event) {
							// console.log('MOVE>>>', event);
						}, this)
					},
					touchEnd1: {
						event: 'touchend',
						target: '.gallery-real-pixels-view',
						callback: fox.bind(function () {
							if (this.doubleTapTime &&
								new Date().getTime() - this.doubleTapTime <= 200) {
								this.hideRealPixels();
								this.doubleTapTime = null;
							} else {
								this.doubleTapTime = new Date().getTime();
							}

							event.preventDefault();
						}, this)
					},
					touchStart: {
						event: 'touchstart',
						target: '.gallery-full-image',
						targetWidget: '#body',
						callback: fox.bind(function (el, alias, scope, event) {
							this._tes = {
								x: event.changedTouches[0].pageX,
								y: event.changedTouches[0].pageY,
								time: new Date().getTime()
							};

							event.preventDefault();
						}, this)
					},
					touchMove: {
						event: 'touchmove',
						target: '.gallery-full-image',
						targetWidget: '#body',
						callback: function (el, alias, scope, event) {
							event.preventDefault();
						}
					},
					touchEnd: {
						event: 'touchend',
						target: '.gallery-full-image',
						targetWidget: '#body',
						callback: fox.bind(function (el, alias, scope, event) {
							var endTouchObj = event.changedTouches[0],
								diffX, direction;
							
							if (this.doubleTapTime
								&& new Date().getTime() - this.doubleTapTime <= 200) {
								this.dispatchEvent('doubleTap');
								this.doubleTapTime = null;

								event.preventDefault();
								return;
							} else {
								this.doubleTapTime = new Date().getTime();
							}

							diffX = this._tes.x - endTouchObj.pageX;

							if ((new Date().getTime() - this._tes.time) <= 400 
								&& Math.abs(diffX) > 100) {
								if (diffX < 0) {
									direction = 'prev';
								} else {
									direction = 'next';
								}
							}

							if (direction !== undefined) {
								this.loadPhoto(direction);
							}

							event.preventDefault();
						}, this)
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.addDocumentListener();
			this.OPENED = false;
		
			this.callParent('init', arguments);

			this._readyToRender = false;
			this._readyToEmbed = false;

			// add templates for comments forms
			this.registerOptions('#imageComments .Social_Comments_Form', fox.mergeRecursive({
				'template': 'sitepage_gallery_fullscreenview_social_comments_addform',
				'embed.container': '.addreview-container',
			}, this.getOption('formOptions')), false, 'fullscreenView.js');

			this.registerOptions('#imageComments .Grid', {
				'list.tpl.row': 'sitepage_gallery_fullscreenview_social_comment',
				'template': 'sitepage_gallery_fullscreenview_social_comments_grid',
			}, false, 'fullscreenView.js');
		},

		addDocumentListener: function () {
			this.addDomHandler({
				event: 'keydown',
				target: document,
				eventChecker: fox.bind(function (event) {
					return this.isEmbedded() && (event.keyCode === 39 || event.keyCode === 37);
				}, this),
				callback: 'handleKeydown'
			}, 'onKeyPress');

			this.addDomHandler({
				event: 'keydown',
				target: document,
				eventChecker: fox.bind(function (event) {
					return this.isEmbedded() && event.keyCode === 27;
				}, this),
				callback: 'hide'
			}, 'onKeyPress');

			return this;
		},

		handleKeydown: function (el, alias, root, event) {
			var direction, keyCode;

			keyCode = ($(el).data('keycode')) ? 
				parseInt($(el).data('keycode')) :
				event.keyCode;

			if (keyCode === 39) {
				direction = 'next';
			} else if (keyCode === 37) {
				direction = 'prev';
			}

			this.loadPhoto(direction);
		},

		loadPhoto: function (direction) {
			var nextIndx, curIndx;

			if ((curIndx = this.collectionSet.indexOf(this.currentPhoto)) !== -1) {
				if (direction === 'next') {
					nextIndx = ++curIndx;
					this.curEffect = 'fadeInRight';
				} else if (direction === 'prev') {
					nextIndx = --curIndx;
					this.curEffect = 'fadeInLeft';
				}

				if (this.collectionSet[nextIndx] !== undefined) {
					this.setCurrentPhoto(this.collectionSet[nextIndx]);

					this.rwom1('#body').render();
					this.hideRealPixels();
				}
			}
		},

		_getImg: function (data) {
			return new fox.RSVP.Promise(function (resolve, reject) {
				var maxFails = 5;

				function load () {
					return $('<img>').attr({
						src: data.url,
						alt: data.altTag
					}).on('load', function () {
						$(this).css('visibility', 'visible');
						return resolve({img: this, id: data.id, status: 'loaded'});
					}).on('error', function () {
						if (!maxFails) return resolve({img: this, id: data.id, status: 'failed'});

						maxFails--;

						return setTimeout(load, 10000);
					}).css('visibility', 'hidden');
				}

				return load();
			}.bind(this));
		},

		setCurrentPhoto: function (data) {
			var curIndx;
			var cacheImg;
			
			this.currentPhoto = data;

			cacheImg = function (data, indx) {
				var _this = this;
				var getImg;
				var timeoutCount = 0;
				var body = this.rwom1('#body');

				var url = data.url;

				if (this.previewThumb && this.previewThumb.length && this.previewThumb[indx]) {
					url = this.previewThumb[indx].url;
				}

				getImg = function () {
					var $img;

					$img = $('<img>').attr({
						src: url,
						alt: 'fullphoto - ' + data.id  + ' - ' + fox.site.environment.screenName
					}).height('100%');

					_this._getImg(data).then(function (resp) {
						var img = resp.img;
						var $img = _this.IMGCACHE[resp.id];

						if (_this.currentPhoto.id === resp.id) {
							$(body.dom1('.gallery-preloader')).hide();
						}

						switch (resp.status) {
							case 'loaded':
								$img.get(0).loadStatus = true;

								$img.attr({src: $(img).attr('src')}).height('auto');
							break;
							case 'failed':
								$img.get(0).loadStatus = undefined;
							break;
						}
					});

					return _.bindToImgJquery(_this.rwom1('#body'), $img);
				};

				return getImg();
			};

			curIndx = this.collectionSet.indexOf(this.currentPhoto);

			this.currentOriginPhoto = this.originThumb && this.originThumb[curIndx] !== undefined ? this.originThumb[curIndx] : this.currentPhoto;

			var cacheLimit = 8;
			var length = this.collectionSet.length;

			if (curIndx !== -1) {
				var i = curIndx < cacheLimit ? 0 : curIndx - cacheLimit;

				for (i; i <= curIndx + cacheLimit && i < length; i++) {
					if (this.collectionSet[i] !== undefined &&
						!this.IMGCACHE.hasOwnProperty(this.collectionSet[i].id)) {
						this.IMGCACHE[this.collectionSet[i].id] = cacheImg.call(this, this.collectionSet[i], i);
					} else {
						continue;
					}
				}
			}

			if (this.IMGCACHE.hasOwnProperty(this.currentPhoto.id)) {
				this.$currentImg = this.IMGCACHE[this.currentPhoto.id];

				if (this.$currentImg.loadStatus === undefined) {
					this.$currentImg = cacheImg.call(this, this.currentPhoto, curIndx);

					this.IMGCACHE[this.currentPhoto.id] = this.$currentImg;
				}
			}

			this.setTemplateOptions({id: this.currentPhoto.id});

			// if already in dom
			if (this._indom) {
				fox.each(fox.dom.select('.social-row'), function(val) { 
					val.setAttribute('data-target-id', this.currentPhoto.id); 
				}, this);		
				this.rwom1('#currentRating').embedding();
				this.rwom1('#imageFavorite').embedding();
			}

			var c = this.rwom1('#imageComments');
			c.setTargetIds([this.currentPhoto.id]);

			var f = this.rwom1('#imageFavorite');
			f.setTargetIds([this.currentPhoto.id]);

			return this;
		},

		render: function () {
			this.callParent('render', arguments);

			this.rwom1('#body').render();
		},

		setPhotoCollection: function (collection, original, preview) {
			collection = this.sortPosition(collection);
			if (collection !== this.collectionSet) {
				this.collectionSet = collection;

				if (original) {
					this.originThumb = this.sortPosition(original);
				}

				if (preview) {
					this.previewThumb = this.sortPosition(preview)
				}
			}

			this.setSocialTargetIds(this.collectionSet);

			return this;
		},

		setSocialTargetIds: function(c) {
			fox.each(c, function (val) {
				this.targetsIds.push(val.id);				
			}, this);			
			
			this.rwom1('#currentRating').setTargetIds(this.targetsIds);
			this.rwom1('#imageFavorite').setTargetIds(this.targetsIds);
		},

		show: function (params) {
			if (this.OPENED === true) {
				return this;
			}

			if (params !== undefined) {
				this.allowDownload = params.allowDownload;
			}

			this.curEffect = 'fadeInDown';

			this._readyToRender = true;
			this._readyToEmbed = true;

			!this.isEmbedded() && this.render();

			this.waitEvent(this, 'addedToDom', function (o, _this) {
				_this._readyToRender = false;
				_this._readyToEmbed = false;
				_this.OPENED = true;
			});

			return this;
		},

		hide: function () {
			if (this.OPENED === true) {
				this.OPENED = false;

				return this.stopSlideshow().cleanMem().removeFromDom();
			}
		},

		cleanMem: function () {
			this.IMGCACHE = null;
			this.IMGCACHE = {};
			this.collectionSet = null;
			this.originThumb = null;
			this.previewThumb = null;
			this.$currentImg = null;

			return this;
		},

		bodyOnStartAddedToDom: function () {
			if (this._readyToRender === false && this.OPENED === false) return false;

			var $imgContainer = $(this.dom1('.gallery-full-image'));

			if (this.$currentImg !== undefined && this.$currentImg[0].loadStatus === undefined) {
				$(this.dom1('.gallery-preloader')).show();
			}

			$imgContainer.html(this.$currentImg).addClass(this.curEffect);
			$(this.dom1('.gallery-fullscreen-view-photo-counter .count')).text(this.collectionSet.indexOf(this.currentPhoto) + 1);
		},

		addedToDom: function () {
			var hintCloseTime = parseInt(fox.utils.localStorage('getItem', '_gchintpanel_'));
			var $controll = $(this.dom1('.gallery-hint-controll'));

			$(this.dom1('.gallery-fullscreen-view-photo-counter .all')).text(this.collectionSet.length);

			if ((!hintCloseTime || (hintCloseTime && (new Date().getTime() > (hintCloseTime + 1000 * 60 * 60)))) && !this.mDeviceDetected()) {
				$controll.show();

				setTimeout(fox.bind(function () {
					$controll.fadeOut('slow');
					fox.utils.localStorage('setItem', '_gchintpanel_', new Date().getTime());
				}, this), 10000);	
			}

			if (this.allowDownload === 0) {
				$(this.dom1('#download-photo')).remove();
			}
		},

		showRealPixel: function () {
			if (!this.currentOriginPhoto) {
				return false;
			}

			var $container = $(this.dom1('.gallery-real-pixels-view')),
				$img = _.bindToImgJquery(this, $('<img>').attr('src', this.currentOriginPhoto.url));

			$container.html($img).show().css('overflow', 'auto');
		},

		hideRealPixels: function () {
			var $container = $(this.dom1('.gallery-real-pixels-view')),
				$el = $(this.dom1('#show-real-pixel'));

			if ($container.is(':visible')) {
				$container.hide('slow');
			}

			if ($el.hasClass('real-px')) {
				$el.removeClass('real-px');
			}

			return this;
		},

		downloadPhoto: function (el) {
			var _this = this;
			var transport = new XMLHttpRequest();
			transport.open('GET', this.currentOriginPhoto.url);
			transport.responseType = 'blob';

			transport.onload = function () {
				var a = document.createElement('a');
				var fname = _this.currentOriginPhoto.altTag.replace(/(\s-\s|\s|\.)/g, '_') + '.jpg';

				if (navigator.msSaveBlob) {
					return navigator.msSaveBlob(transport.response, fname);
				}

				if (window.URL || typeof safari !== 'undefined') {
					//if ('download' in a) {
						a.href = window.URL.createObjectURL(transport.response);
						a.setAttribute('download', fname);
						document.body.appendChild(a);

						setTimeout(function () {
							a.click();

							document.body.removeChild(a);
						}, 100);
					//}

					return true;
				}
			};

			transport.send();
		},

		startSlideshow: function () {
			var switchInt = parseInt(this.getOption('slideSwitchInterval'));
			$(this.dom1('.gallery-sidebar')).toggleClass('opened');
			$(this.dom1('.gallery-fullscreen-stop-slide-show')).show();

			this.slideshowStarted = setInterval(fox.bind(function () {
				var nextIndx = this.collectionSet.indexOf(this.currentPhoto);

				if (this.collectionSet[++nextIndx] !== undefined) {
					this.loadPhoto('next');
				}

				if (nextIndx === this.collectionSet.length) {
					this.setCurrentPhoto(this.collectionSet[0]);

					this.rwom1('#body').render();
				}
			}, this), switchInt);
		},

		stopSlideshow: function () {
			if (this.slideshowStarted) {
				clearInterval(this.slideshowStarted);
				this.slideshowStarted = null;
			};

			return this;
		},

		stopSlideshowHandler: function (el) {
			$(el).hide();
			$(this.dom1('.gallery-sidebar')).toggleClass('opened');

			return this.stopSlideshow();
		},

		mDeviceDetected: function () {
			var 
				platform = window.navigator.userAgent,
				mDevices = [
				    {device: 'Android', platform: /Android/},
				    {device: 'iPhone', platform: /iPhone/},
				    {device: 'iPad', platform: /iPad/},
				    {device: 'Symbian', platform: /Symbian/},
				    {device: 'Windows Phone', platform: /Windows Phone/},
				    {device: 'Tablet OS', platform: /Tablet OS/}
				];

			for (var i = mDevices.length; i--;) {
				if (mDevices[i]['platform'].test(platform)) {
					return true;
				}
			}

			return false;
		},
		sortPosition: function (sortObj) {
			return sortObj.sort(function (a, b) {
				return a.position < b.position ? -1 : a.position > b.position ? 1 : 0;
			});
		}

	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/gallery/fullscreenView.js
// module id = 901
// module chunks = 4